export default "__VITE_ASSET__DDozX_To__"